// import { extendTheme } from "@material-ui/core/styles";

import {
  Experimental_CssVarsProvider as CssVarsProvider,
  experimental_extendTheme as extendTheme,
} from '@mui/material/styles';

const theme = extendTheme({
  palette: {
    primary: {
      main: "#B93A76",
    },
    secondary: {
      main: "#5a6268",
    },
    tertiary: {
      main: "#F6503C",
    },
  },
  typography: {
    fontFamily: 'Poppins'
  }
});

export default theme;
